"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = require("react");
// The iOS status bar in safari inherits the background color of the body: https://css-tricks.com/the-notch-and-css/

var useIPhoneSafariStatusBarColor = function useIPhoneSafariStatusBarColor(_ref) {
  var _ref$isActive = _ref.isActive,
    isActive = _ref$isActive === void 0 ? true : _ref$isActive,
    color = _ref.color;
  // TODO: create DeviceService in react
  var isIPhone = navigator.userAgent.match(/iPhone/i);

  // eslint-disable-next-line consistent-return
  (0, _react.useEffect)(function () {
    if (isIPhone && isActive) {
      var meta = document.createElement('meta');
      meta.setAttribute('name', 'theme-color');
      meta.setAttribute('content', color);
      document.head.appendChild(meta);
      return function () {
        document.head.removeChild(meta);
      };
    }
  }, [isIPhone, isActive, color]);
};
var _default = exports["default"] = useIPhoneSafariStatusBarColor;
//# sourceMappingURL=useIPhoneSafariStatusBarColor.js.map